const content = {
  title: "Present Continuous",
  explanation: `
We use the Present Continuous for actions happening right now.
Example: I am reading this sentence now.

We also use it for temporary actions around the present period.
Example: She is staying with her aunt this week.

It describes actions in progress, not habits or permanent facts.
Example: They are working on a school project these days.

At A1 level, remember the pattern: am/is/are + verb-ing.
Example: He is playing in the garden.
  `,
  rules: [
    "Subject + am / is / are + verb + ing",
    "I am (I'm) studying",
    "He / She / It is (he's) working",
    "We / You / They are (we're) learning"
  ],
  examples: [
    "I am studying English right now.",
    "She is talking on the phone.",
    "They are playing football at the moment.",
    "He is working on a new project.",
    "We are learning a new grammar rule."
  ]
};

export default content;


